import React, { Component } from "react";
import { bindActionCreators } from "redux";

import connect from "react-redux/es/connect/connect";
import { trimFormData } from "../../../../utils/common";
import * as validator from "../../../../utils/validator";

import "./UserManagementStyles.scss";

import UserManagementView from "./UserManagementView";
import {
  getUserList,
  addUser,
  editUser,
  deleteUser,
  updateRowsPerPage,
  updateCurrentPage,
  updateSearchFilters,
} from "../../../../store/userManagement/userManagementActions";
import {
  getRoleList,
  // updateRowsPerPage,
} from "../../../../store/master/masterActions";

class UserManagementContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: {
        showViewModal: false,
        showAddModal: false,
        showEditModal: false,
        showDeleteModal: false,
      },
      userData: {},
      // fields: {},
      fields: this?.props?.fields || {
        searchValue: "",
      },
      errors: {},
      // rowsPerPage: { label: "10", value: "10" },
      rowsPerPage: this.props?.rowsPerPage || { label: "10", value: 10 },
      currentPage: this.props.currentPage || 1,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleRoleChange = this.handleRoleChange.bind(this);
    this.handleTableRowsChange = this.handleTableRowsChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    //
    this.handleClear = this.handleClear.bind(this);
    //
    this.onClickAddUser = this.onClickAddUser.bind(this);
    this.onClickEditUser = this.onClickEditUser.bind(this);
    //
    this.onClickAddUserSubmit = this.onClickAddUserSubmit.bind(this);
    this.onClickEditUserSubmit = this.onClickEditUserSubmit.bind(this);
    this.onClickDeleteUserSubmit = this.onClickDeleteUserSubmit.bind(this);
    this.onChangeSearchInput = this.onChangeSearchInput.bind(this);
    this.onClickSearch = this.onClickSearch.bind(this);
    //
    this.capitalizeWords = this.capitalizeWords.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log(this.props.userList);
    const page = this.props?.userList?.page;
    const limit = this.props?.userList?.limit;

    // if (prevProps.userList?.page !== page) {
    //   this.setState((prev) => ({
    //     ...prev,
    //     currentPage: page,
    //     rowsPerPage: { label: `${limit}`, value: limit },
    //   }));
    // }

    this.stateUpdatesOnComponentUpdates(prevProps, prevState);
  }

  //--------------------------update state on component update
  stateUpdatesOnComponentUpdates = (prevProps, prevState) => {
    if (prevProps.currentPage !== this.props?.currentPage) {
      this.setState((prev) => ({
        ...prev,
        currentPage: this.props?.currentPage,
      }));
    }
  };

  componentDidMount() {
    const data = {
      isActive: true,
      userName: this.state?.fields?.searchValue?.trim(),
    };
    this.props.getUserList(
      data,
      this.state?.currentPage,
      this.state?.rowsPerPage?.value
    );
    this.props.getRoleList();
  }

  componentWillUnmount() {
    this.resetTheReduxStateOnUnmount();
  }

  resetTheReduxStateOnUnmount = () => {
    //--------------------------reset redux rowsPerPage state when unmounting
    const resetRowsPerPageData = { label: "10", value: 10 };
    this.props?.updateRowsPerPage(resetRowsPerPageData);
    this.props?.updateCurrentPage(1);
    //--------------------------reset redux fields state when unmounting
    const resetFields = { searchValue: "" };
    this.props.updateSearchFilters(resetFields);
  };

  //--------------------------popup modal handlers

  onClickViewUser = (data) => {
    this.setState((prevState) => ({
      showModal: { ...prevState.showModal, showViewModal: true },
      userData: data,
    }));
  };

  onClickAddUser = () => {
    this.setState((prevState) => ({
      showModal: { ...prevState.showModal, showAddModal: true },
      errors: {},
    }));
  };

  onClickEditUser = (data) => {
    console.log("data", data);
    const existingUserRole = [
      { label: data?.roleId[0].role, value: data?.roleId[0]._id },
    ];
    this.setState((prevState) => ({
      showModal: { ...prevState.showModal, showEditModal: true },
      userData: data,
      fields: {
        ...prevState.fields,
        name: data?.userName,
        email: data?.email,
        role: existingUserRole,
      },
    }));
  };

  onClickDeleteUser = (data) => {
    this.setState((prevState) => ({
      showModal: { ...prevState.showModal, showDeleteModal: true },
      userData: data,
    }));
  };

  onCloseModal = () => {
    this.setState((prevState) => ({
      showModal: {
        showViewModal: false,
        showAddModal: false,
        showEditModal: false,
        showDeleteModal: false,
      },
      fields: { searchValue: this.state?.fields?.searchValue },
      errors: {},
      rowsPerPage: this.state?.rowsPerPage,
      currentPage: this.state?.currentPage,
    }));
  };

  //--------------------------field handlers

  handleInputChange = ({ target }) => {
    const field = target.name;
    // console.log(this.state.fields);
    // this.setState({
    //   fields: { ...this.state.fields, [field]: target.value },
    //   errors: {},
    // });

    this.setState(
      (prevState) => {
        const updatedErrors = { ...prevState.errors };
        delete updatedErrors[field]; // Remove the error for the updated field

        return {
          fields: {
            ...prevState.fields,
            [field]: target.value,
          },
          errors: updatedErrors,
        };
      },
      () => console.log(this.state.fields)
    );
  };

  // handleRoleChange = (value) => {
  //   // console.log(this.state.fields);
  //   this.setState({
  //     fields: { ...this.state.fields, role: value },
  //   });
  // };

  handleRoleChange = (value) => {
    this.setState((prevState) => {
      const updatedErrors = { ...prevState.errors };
      delete updatedErrors.role; // Remove the error for the role field

      return {
        fields: {
          ...prevState.fields,
          role: value,
        },
        errors: updatedErrors,
      };
    });
  };

  handleTableRowsChange = (value) => {
    this.setState((prev) => ({ ...prev, rowsPerPage: value, currentPage: 1 }));
    // this.props.updateRowsPerPage(value);
    const data = {
      isActive: true,
      userName: this.state?.fields?.searchValue?.trim(),
    };
    this.props.getUserList(data, 1, value?.value);
  };

  handleChangePage = (page) => {
    this.setState((prev) => ({ ...prev, currentPage: page }));
    const data = {
      isActive: true,
      userName: this.state?.fields?.searchValue?.trim(),
    };
    this.props.getUserList(data, page, this.state.rowsPerPage?.value);
  };

  //--------------------------Add new user
  capitalizeWords = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  renderEmailErrorMessage = () => {
    // if email address already in use then show error in form
    const formMailErrorMessage = { email: "email address already in use" };
    this.setState({ ...this.state, errors: formMailErrorMessage });
  };

  onClickAddUserSubmit = () => {
    var fields = this.state.fields;

    const searchValueExist = fields?.searchValue !== "" ? true : false;
    // console.log(searchValueExist);
    const validatorFields = {
      required: ["name", "email", "password", "role"],
      custom: [validator.email(["email"]), validator.password(["password"])],
    };
    const { errors } = validator.validate(
      validatorFields,
      // trimFormData(fields)
      fields
    );

    this.setState({ ...this.state, errors });
    console.log(errors);
    var fields = this.state.fields;
    if (!Object.keys(errors).length) {
      const data = {
        userName: this.capitalizeWords(fields.name),
        email: fields.email,
        password: fields.password,
        roleId: fields.role.value,
      };
      console.log("add user data", data);
      this.props.addUser(
        data,
        fields?.searchValue,
        () => {
          const data = {
            isActive: true,
            userName: fields?.searchValue?.trim(),
          };

          this.props.getUserList(
            data,
            this.state?.currentPage,
            this.state?.rowsPerPage?.value
          );
          //------------------------
          // if (searchValueExist) {
          //   const onAddUserSearchValue = true;
          //   this.onClickSearch(onAddUserSearchValue);
          // } else {
          //   data = { isActive: true };
          //   this.props.getUserList(
          //     data,
          //     this.state?.currentPage,
          //     this.state?.rowsPerPage?.value
          //   );
          // }
        },
        () => {
          this.onCloseModal();
        },
        () => {
          this.renderEmailErrorMessage();
        }
      );
      // this.onCloseModal();
    }
  };

  //--------------------------Edit user
  onClickEditUserSubmit = (id) => {
    var fields = this.state.fields;

    const searchValueExist = fields?.searchValue !== "" ? true : false;

    const validatorFields = {
      required: ["name", "email"],
      custom: [validator.email(["email"])],
    };
    const { errors } = validator.validate(
      validatorFields,
      // trimFormData(fields)
      fields
    );

    this.setState({ ...this.state, errors });

    var fields = this.state.fields;
    if (!Object.keys(errors).length) {
      const data = {
        userName: this.capitalizeWords(fields.name),
        email: fields.email,
        // password: fields.password,
        roleId: fields.role?.value,
      };
      this.props.editUser(
        id,
        data,
        fields?.searchValue,
        () => {
          if (searchValueExist) {
            const onAddUserSearchValue = true;
            this.onClickSearch(onAddUserSearchValue); //it is used to get filtered data
          } else {
            const data = {
              isActive: true,
              userName: this.state?.fields?.searchValue?.trim(),
            };
            this.props.getUserList(
              data,
              this.state?.currentPage,
              this.state?.rowsPerPage?.value
            );
          }
        },
        () => {
          this.onCloseModal();
        },
        () => {
          this.renderEmailErrorMessage();
        }
      );
      // this.onCloseModal();
    }
  };

  //--------------------------Delete user
  onClickDeleteUserSubmit = (id) => {
    var fields = this.state.fields;

    this.props.deleteUser(id, fields?.searchValue, () => {
      const data = { isActive: true, userName: fields?.searchValue?.trim() };

      this.props.getUserList(
        data,
        this.state?.currentPage,
        this.state?.rowsPerPage?.value
      );
    });

    // const searchValueExist = fields?.searchValue !== "" ? true : false;

    // this.props.deleteUser(id, fields?.searchValue, () => {
    //   if (searchValueExist) {
    //     const onAddUserSearchValue = true;
    //     this.onClickSearch(onAddUserSearchValue);
    //     this.onCloseModal();
    //   } else {
    //     const data = { isActive: true };
    //     console.log(this.state.currentPage);
    //     console.log(this.state.rowsPerPage);
    //     this.props.getUserList(
    //       data,
    //       this.state?.currentPage,
    //       this.state?.rowsPerPage?.value
    //     );
    //     this.onCloseModal();
    //   }
    // });
    this.onCloseModal();
  };

  //--------------------------Search user
  onChangeSearchInput = (e) => {
    // const { value } = e.target;
    const field = e.target.name;
    const { value } = e.target;
    this.setState(
      // (prev) => ({
      //   ...prev,
      //   fields: { ...prev.fields, searchValue: value },
      // }),
      (prevState) => {
        const updatedErrors = { ...prevState.errors };
        delete updatedErrors[field]; // Remove the error for the updated field

        return {
          fields: {
            ...prevState.fields,
            [field]: value,
          },
          errors: updatedErrors,
        };
      },
      () => {
        if (this.state.fields?.searchValue === "") {
          const data = { isActive: true };
          this.props.getUserList(
            data,
            this.state?.currentPage,
            this.state?.rowsPerPage?.value
          );
        }
        //update redux state
        this.props.updateSearchFilters(this?.state?.fields);
      }
    );
  };

  handleClear = () => {
    // console.log(this.state.fields);
    this.setState(
      // (prev) => ({
      //   ...prev,
      //   fields: { ...prev.fields, searchValue: "" },
      // }),
      (prevState) => {
        const updatedErrors = { ...prevState.errors };
        delete updatedErrors.searchValue; // Remove the error for the updated field

        return {
          fields: {
            ...prevState.fields,
            searchValue: "",
          },
          errors: updatedErrors,
        };
      },
      () => {
        if (this.state.fields?.searchValue === "") {
          const data = { isActive: true };
          this.props.getUserList(
            data,
            this.state?.currentPage,
            this.state?.rowsPerPage?.value
          );
        }
        //update redux state
        this.props.updateSearchFilters(this?.state?.fields);
      }
    );
  };

  onClickSearch = (onAddUserSearchValue) => {
    var fields = this.state.fields;
    console.log("fields", fields);

    const validatorFields = {
      required: ["searchValue"],
    };
    const { errors } = validator.validate(
      validatorFields,
      trimFormData(fields)
      // fields
    );

    // Add custom error message
    const updatedErrors = {
      ...errors,
      searchValue: errors?.searchValue && "Please enter valid input",
    };

    this.setState({ ...this.state, errors: updatedErrors });

    const searchData = {
      isActive: true,
      userName: this.state?.fields?.searchValue.trim(),
    };

    const addUserSearchData = {
      isActive: true,
      userName: this.state?.fields?.searchValue.trim(),
    };

    const dynamicData = onAddUserSearchValue ? addUserSearchData : searchData;
    // console.log("dynamicData", dynamicData);

    if (!Object.keys(errors).length) {
      onAddUserSearchValue
        ? this.props.getUserList(
            dynamicData,
            this.state?.currentPage,
            this.state?.rowsPerPage?.value
          )
        : this.props.getUserList(
            dynamicData,
            1,
            this.state?.rowsPerPage?.value
          );

      console.log("searchData", dynamicData);
    }
  };

  render() {
    //--------------------------dropdown options
    const roleListDropDownOptions = this.props?.roleList?.map((item) => ({
      label: item?.role,
      value: item?._id,
    }));

    const rowsPerPageDropDownOptions = [
      { label: "10", value: 10 },
      { label: "15", value: 15 },
      { label: "20", value: 20 },
      { label: "25", value: 25 },
      { label: "30", value: 30 },
    ];

    return (
      <UserManagementView
        //all the states
        showModal={this.state.showModal}
        fields={this.state.fields}
        errors={this.state.errors}
        userData={this.state.userData}
        userList={this.props.userList}
        currentPage={this.state?.currentPage}
        rowsPerPage={this.state?.rowsPerPage}
        // showRowsPerPage={this.props.showRowsPerPage}
        //modal handler
        onClickViewUser={this.onClickViewUser}
        onClickAddUser={this.onClickAddUser}
        onClickEditUser={this.onClickEditUser}
        onClickDeleteUser={this.onClickDeleteUser}
        handleCloseModal={this.onCloseModal}
        //input handler
        handleInputChange={this.handleInputChange}
        handleRoleChange={this.handleRoleChange}
        handleTableRowsChange={this.handleTableRowsChange}
        handleChangePage={this.handleChangePage}
        handleClear={this.handleClear}
        //API's
        onClickAddUserSubmit={this.onClickAddUserSubmit}
        onClickEditUserSubmit={this.onClickEditUserSubmit}
        onClickDeleteUserSubmit={this.onClickDeleteUserSubmit}
        onChangeSearchInput={this.onChangeSearchInput}
        onClickSearch={this.onClickSearch}
        //dropdown options
        // roleListDropDownOptions={this.roleListDropDownOptions}
        // rowsPerPageDropDownOptions={this.rowsPerPageDropDownOptions}
        roleListDropDownOptions={roleListDropDownOptions}
        rowsPerPageDropDownOptions={rowsPerPageDropDownOptions}
        //
        userPermissions={this.props.userPermissions}
      />
    );
  }
}

UserManagementContainer.propTypes = {};

const mapStateToProps = (state) => ({
  userList: state.userManagement.userList,
  searchValue: state.userManagement.searchValue,
  currentPage: state.userManagement.currentPage,
  rowsPerPage: state.userManagement.rowsPerPage,
  fields: state.userManagement.fields,
  showRowsPerPage: state.master.showRowsPerPage,
  roleList: state.master.roleList,
  userPermissions: state.auth.userPermissions,
});

export default connect(mapStateToProps, {
  getUserList,
  addUser,
  editUser,
  deleteUser,
  getRoleList,
  //
  // updateRowsPerPage,
  updateRowsPerPage,
  updateSearchFilters,
  updateCurrentPage,
})(UserManagementContainer);
